import { useRef, useEffect } from 'react';
import { cn } from '@/utils/cn';
import { testimonials } from '@/constants/testimonials';
import TestimonialCard from './TestimonialCard';

const TestimonialSlider = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const slider = sliderRef.current;
    const container = containerRef.current;
    if (!slider || !container) return;

    let animationFrameId: number;
    let isHovering = false;
    let position = 0;

    const scroll = () => {
      if (!isHovering) {
        position += 0.5;
        if (position >= slider.scrollWidth / 2) {
          position = 0;
        }
        slider.scrollLeft = position;
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    // Clone testimonials for infinite scroll
    const clonedItems = slider.innerHTML;
    slider.innerHTML = clonedItems + clonedItems;

    // Start animation
    animationFrameId = requestAnimationFrame(scroll);

    // Hover handlers
    const handleMouseEnter = () => {
      isHovering = true;
    };

    const handleMouseLeave = () => {
      isHovering = false;
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationFrameId);
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div className="relative">
      <div 
        ref={containerRef}
        className="relative overflow-hidden px-12"
      >
        {/* Blur edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-gray-50 to-transparent z-20 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-gray-50 to-transparent z-20 pointer-events-none" />
        
        <div 
          ref={sliderRef}
          className={cn(
            "flex gap-6 overflow-hidden",
            "[&>*]:flex-shrink-0 [&>*]:w-[400px]"
          )}
        >
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              {...testimonial}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;